export interface ManagementData {
  addDate: number;
  analyticalCategory: string;
  statisticCategory: string;
  riskLevel: number;
  contractType: string;
  contractId: string;
  membershipNumber: string;
  termination: boolean;
  terminationDate?: Date;
  serienNr: string;
  deviceType?: string;
  deviceFonNumber?: string;
  deviceCall?: string;
  locationDesc?: string;
  radioReceiver?: Array<any>;
  contactPerson?: any;
  flatKey?: string;
  keyDesc?: string;
  billingType?:string;
}

export class ManagementData implements ManagementData {
  addDate: number = new Date().getTime() as number;
  analyticalCategory = '';
  statisticCategory = '';
  riskLevel = 0;
  contractType = '';
  contractId = '';
  membershipNumber = '';
  termination = false;
  terminationDate?: Date;
  serienNr = '';
  deviceType ? = '';
  deviceFonNumber ? = '';
  locationDesc ? = '';
  radioReceiver ? = [];
  flatKey ? = 'nein';
  keyDesc ? = '';
}
